// `../ziggy.js` is GENERATED by `php artisan ziggy:generate` (webpack.mix.js runs
// it before every build) and is git-ignored. It carries a NAMED export.
//
// PS-10341: ziggy 0.6 -> 1.8 changed BOTH halves and they must move together.
// The generated file went from `var Ziggy = { namedRoutes: ... }` to
// `const Ziggy = { routes: ... }`, and the helper reads `routes`. The 0.5.0
// helper this used to require (a GitHub tarball pinned in package.json) looks
// for `namedRoutes`, finds nothing in a 1.8 payload, and every route() call
// throws -- at runtime, in the browser. The 1.8 helper ships inside the
// composer package as a UMD build, so it is required from vendor/ rather than
// adding an npm dependency; the same checkout always carries matching halves.
window.Ziggy = require('../ziggy.js').Ziggy;
window.route = require('../../../../vendor/tightenco/ziggy/dist/index.js');



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap/ziggy.js